import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IhmErrorComponent } from './ihm-error.component';

const errorRoutes: Routes = [
  {
    path: '',
    component: IhmErrorComponent
  },
  {
    path: ':errorId',
    component: IhmErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(errorRoutes)],
  exports: [RouterModule]
})
export class IhmErrorRoutingModule {}
